document.addEventListener('DOMContentLoaded', () => {
  // 获取所有带有joe_tran-header类的元素
  const transparentHeaderElements = document.querySelectorAll('.joe_tran-header');
  
  // 如果没有找到相关元素，则直接返回
  if (transparentHeaderElements.length === 0) return;
  
  // 保存初始标记有该类的元素，用于后续恢复
  const originalTransparentElements = new Set();
  transparentHeaderElements.forEach(element => {
    originalTransparentElements.add(element);
  });
  
  // 创建一个observer实例，用于监听元素是否在视口中
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const targetElement = entry.target;
      
      // 当元素离开视口时
      if (!entry.isIntersecting) {
        // 元素已完全滑出视野，移除joe_tran-header类
        targetElement.classList.remove('joe_tran-header');
      }
      // 当元素重新进入视口且是原始透明元素时
      else if (originalTransparentElements.has(targetElement)) {
        // 元素滑回视野，重新添加joe_tran-header类
        targetElement.classList.add('joe_tran-header');
      }
    });
  }, {
    // root: null表示使用视口作为参照
    root: null,
    // rootMargin可以扩展或缩小视口的判定范围，这里为顶部增加一点空间
    rootMargin: '0px',
    // threshold为0表示元素刚开始进入或离开视口时就会触发
    threshold: 0
  });
  
  // 为每个透明头部元素添加观察者，并保持持续观察
  transparentHeaderElements.forEach(element => {
    observer.observe(element);
  });
  
  // 处理页面加载时已经滚动的情况
  setTimeout(() => {
    transparentHeaderElements.forEach(element => {
      const rect = element.getBoundingClientRect();
      // 如果页面加载时元素不在视口中
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
        element.classList.remove('joe_tran-header');
      }
    });
  }, 100);
  
  // 额外检查：确保在某些边缘情况下能正确处理类的添加和删除
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      originalTransparentElements.forEach(element => {
        const rect = element.getBoundingClientRect();
        
        // 元素不在视口内，应移除类
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
          if (element.classList.contains('joe_tran-header')) {
            element.classList.remove('joe_tran-header');
          }
        } 
        // 元素在视口内，应添加类
        else {
          if (!element.classList.contains('joe_tran-header')) {
            element.classList.add('joe_tran-header');
          }
        }
      });
    }, 100);
  });
});